import { useLingui } from '@lingui/react/macro';

import type { PerioToothData } from '@/modules/insuranceExport/types';

import { BleedingDots } from './BleedingDots';
import { MeasurementRow } from './MeasurementRow';
import type { MeasurementType, Side } from './types';

export const MeasurementSection = ({
  teeth,
  side,
}: {
  teeth: PerioToothData[];
  side: Side;
}) => {
  const { t } = useLingui();
  const measurements: { label: string; type?: MeasurementType }[] = [
    { label: t`Probing Depth`, type: 'probingDepth' },
    { label: t`Gingival Margin`, type: 'gingivalMargin' },
    { label: t`Clinical Attachment Level`, type: 'clinicalAttachmentLevel' },
    { label: t`Mucogingival Junction` },
    { label: t`Furcation Grade` },
    { label: t`Bleeding` },
    { label: t`Suppuration` },
  ];

  return (
    <div className="vai-text-xs">
      {measurements.map(({ label, type }) => (
        <div key={label} className="vai-flex vai-border-b vai-border-gray-400">
          <div className="vai-w-40 vai-p-1 vai-font-semibold vai-bg-gray-50 vai-border-r vai-border-gray-400">
            {label}
          </div>
          <div className="vai-flex vai-flex-1">
            {type ? (
              <MeasurementRow
                teeth={teeth}
                measurementType={type}
                side={side}
              />
            ) : label === t`Bleeding` ? (
              teeth.map((tooth, index) => (
                <div
                  key={tooth.toothNumber}
                  className={`vai-flex-1 vai-p-2 ${
                    index < teeth.length - 1
                      ? 'vai-border-r vai-border-gray-400'
                      : ''
                  }`}
                >
                  <BleedingDots tooth={tooth} side={side} />
                </div>
              ))
            ) : (
              teeth.map((tooth, index) => (
                <div
                  key={tooth.toothNumber}
                  className={`vai-flex-1 vai-p-1 vai-text-center ${
                    index < teeth.length - 1
                      ? 'vai-border-r vai-border-gray-400'
                      : ''
                  }`}
                >
                  {label === t`Mucogingival Junction` ||
                  label === t`Furcation Grade`
                    ? '---'
                    : ''}
                </div>
              ))
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
